import { HEBREW_MONTHS } from "@/lib/calApi";

const field = "px-3 py-2.5 rounded-xl bg-paper border border-line text-sm text-cocoa focus:outline-none focus:ring-2 focus:ring-amber-deep/30";

// Inputs de fecha hebrea: día / mes / año (ej. 23 de Tamuz 5730).
export function HebrewDateFields({ value, onChange, testId }) {
  const v = value || { day: "", month: "Tishrei", year: "" };
  const set = (k, x) => onChange({ ...v, [k]: x });
  return (
    <div className="grid grid-cols-[70px_1fr_90px] gap-2" data-testid={testId}>
      <input type="number" min="1" max="30" placeholder="Día" value={v.day} onChange={(e) => set("day", e.target.value)} className={field} data-testid={`${testId}-day`} />
      <select value={v.month} onChange={(e) => set("month", e.target.value)} className={field} data-testid={`${testId}-month`}>
        {HEBREW_MONTHS.map(([k, label]) => <option key={k} value={k}>{label}</option>)}
      </select>
      <input type="number" min="5600" max="6000" placeholder="Año" value={v.year} onChange={(e) => set("year", e.target.value)} className={field} data-testid={`${testId}-year`} />
    </div>
  );
}

export const inputClass = `w-full ${field}`;
